<template>
  <div class="bg-white">
    <div class="flex mdmax:flex-col">
      <div class="p-6 flex-1 shadow-border-r mdmax:shadow-border-b">
        <p class="font-bold text-lg mb-6">Info Partner</p>
        <div class="mb-6" v-if="partnerDetail?.delivery_service?.logo">
          <div class="w-24 h-24 p-4 rounded-full border border-neutral-300">
            <img :src="partnerDetail?.delivery_service?.logo" class="rounded-full" />
          </div>
        </div>
        <div class="mb-6">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">ID</label>
          <p class="text-neutral-500">{{ partnerDetail.id }}</p>
        </div>
        <div class="mb-6">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Nama</label>
          <p class="text-neutral-500">{{ partnerDetail.name }}</p>
        </div>
        <div class="flex items-start gap-6 mb-6">
          <div class="w-44 mdmax:flex-1 mdmax:w-auto">
            <label class="text-sm text-neutral-700 font-medium mb-1 block">Status</label>
            <p
              class="inline-block text-sm font-bold text-white px-2 py-1 rounded-md capitalize"
              :class="[partnerDetail?.delivery_service?.status === 'ACTIVE' ? 'bg-system-success' : 'bg-system-error']"
            >
              {{ partnerDetail?.delivery_service?.status?.toLowerCase() }}
            </p>
          </div>
          <div class="">
            <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Tipe Partner</label>
            <p class="text-neutral-500">{{ partnerType }}</p>
          </div>
        </div>
        <div class="flex items-start gap-6 mb-6">
          <div class="w-44 mdmax:flex-1 mdmax:w-auto">
            <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Tanggal Kontrak Dimulai</label>
            <p class="text-neutral-500">{{ partnerDetail.contract_start | formatDate }}</p>
          </div>
          <div class="">
            <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Tanggal Kontrak Berakhir</label>
            <p class="text-neutral-500">{{ partnerDetail.contract_end | formatDate }}</p>
          </div>
        </div>
        <div class="mb-6" v-if="partnerDetail.notification_url">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">URL Notifikasi</label>
          <p class="text-neutral-500">{{ partnerDetail.notification_url }}</p>
        </div>
      </div>
      <div class="p-6 flex-1 mdmax:flex-auto mdmax:w-full">
        <p class="font-bold text-lg mb-6">Info Rekening</p>
        <div class="mb-6">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Nama Bank</label>
          <p class="text-neutral-500">{{ bankName }}</p>
        </div>
        <div class="mb-6">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">No Rekening</label>
          <p class="text-neutral-500">{{ partnerDetail.bank_account_no }}</p>
        </div>
      </div>
    </div>
    <div class="flex justify-end items-center p-6 shadow-border-t">
      <Button
        :buttonText="partnerDetail?.delivery_service?.status === 'ACTIVE' ? 'Nonaktifkan' : 'Aktifkan'"
        :type="partnerDetail?.delivery_service?.status === 'ACTIVE' ? 'delete' : 'success'"
        @action="toggleUpdateConfirmation()"
      />
    </div>
    <Modal :modalVisible="visibleUpdateConfirmation" @close="toggleUpdateConfirmation()" width="600px" id="change-modal">
      <template slot="modal-content">
        <div class="flex items-center justify-start gap-6 mb-6">
          <span class="flex-shrink-0"><Alert color="neutral-700" /></span>
          <div class="flex-col flex gap-2 items-start">
            <p class="text-2xl font-bold">Perubahan Status</p>
            <p class="text-sm text-neutral-500 text-left">Anda yakin akan me{{ partnerDetail?.delivery_service?.status === 'ACTIVE' ? 'nonaktifkan' : 'ngaktifkan' }} partner ini?</p>
          </div>
        </div>
        <div class="flex justify-end gap-4">
          <Button buttonText="Tidak" type="secondary" @action="toggleUpdateConfirmation()" :size="isMobile ? 'full' : 'regular'" />
          <Button buttonText="Ya" type="primary" @action="proceed()" :size="isMobile ? 'full' : 'regular'" />
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { formatDate, showVueToast } from '@/util'
export default {
  filters: {
    formatDate
  },
  components: {
    Button: () => import(/* webpackChunkName: "Button" */ '@/components/Forms/Button'),
    Alert: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/Alert'),
    Modal: () => import(/* webpackChunkName: "Modal" */ '@/components/Modal/Modal')
  },
  computed: {
    ...mapGetters('partner', ['partnerDetail', 'partnerTypes']),
    ...mapGetters('master', ['bankCodes']),
    ...mapGetters('common', ['isMobile']),
    partnerId() {
      return this.$route.params.id
    },
    partnerType() {
      return this.partnerTypes && this.partnerTypes.filter((item) => item.id === this.partnerDetail.partner_type)[0]?.name
    },
    bankName() {
      return this.bankCodes && this.bankCodes.filter((item) => item.code === this.partnerDetail.bank_id)[0]?.name
    },
    preferedStatus() {
      return this.partnerDetail?.delivery_service?.status === 'ACTIVE' ? 'inactive' : 'active'
    }
  },
  data() {
    return {
      visibleUpdateConfirmation: false
    }
  },
  async created() {
    await this.getPartnerTypes()
    await this.getBankCodes()
    this.getPartnerInfo()
  },
  methods: {
    ...mapActions('common', ['showLoading', 'hideLoading']),
    ...mapActions('partner', ['getPartnerDetail', 'getPartnerTypes', 'updateStatus']),
    ...mapActions('master', ['getBankCodes']),
    proceed() {
      this.toggleUpdateConfirmation()
      let self = this
      this.showLoading()
      this.updateStatus({
        id: this.partnerId,
        payloads: { status: self.preferedStatus }
      }).then(() => {
        this.hideLoading()
        this.getPartnerInfo()
      })
    },
    toggleUpdateConfirmation() {
      this.visibleUpdateConfirmation = !this.visibleUpdateConfirmation
    },
    getPartnerInfo() {
      this.showLoading()
      this.getPartnerDetail({
        partnerId: this.partnerId
      })
        .then(() => {
          this.hideLoading()
        })
        .catch(() => {
          this.hideLoading()
          showVueToast('Terjadi kesalahan!', 'error', 3000)
          this.$router.push('/partner')
        })
    }
  }
}
</script>
